import { baseApi } from '@shared/api'

export const idCardFileUploadApi = baseApi.injectEndpoints({
  endpoints(builder) {
    return {
      idCardFileUpload: builder.mutation<any, any>({
        query: (files) => ({
          url: '/ib/core/v1/file/upload',
          data: files,
          method: 'POST',
          file: 'upload',
          skipGlobalError: true,
          headers: {
            'Content-Type': 'multipart/form-data;'
          }
        }),
      }),
      idCardFileDownload: builder.mutation<any, any>({
        query: ({ fileId }) => ({
          url: `/ib/core/v1/file/download/${fileId}`,
          method: 'POST',
          data: {},
          file: 'download',
          skipGlobalError: true,
          headers: {
            'Accept': '*/*'
          }
          // responseHandler: async (response) => {
          //   const blob = await response.blob();
          //   const headers = Object.fromEntries(response.headers.entries());
          //   return { blob, headers };
          // },
        })
      })
    }
  },
})

export const {
  useIdCardFileUploadMutation,
  useIdCardFileDownloadMutation,
} = idCardFileUploadApi
